/* eslint no-underscore-dangle: 0 */
import React, { useEffect, useState } from 'react';
import { Link } from 'gatsby';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { Container } from './styles/Container.styled';
import { Row } from './styles/Row.styled';
import { Column } from './styles/Column.styled';
import { SearchResultsContainer, StyledInput } from './styles/SearchResultsPage.styled';

function SearchResults({ dir, id }) {
  const isBrowser = typeof window !== 'undefined';
  const queryParams = new URLSearchParams(isBrowser && window.location.search);
  const [results, setResults] = useState([]);
  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;
  const [term, setTerm] = useState(queryParams.get('q') || '');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  let allowedTypes = ['dwtcPage', 'dwtcHome', 'insight', 'article', 'event'];
  // Search page
  const doSearch = () => {
    if (!term) return;
    if (dir === 'rtl') {
      allowedTypes = ['dwtcPage', 'dwtcHome', 'article', 'event'];
    }
    setLoading(true);
    setError('');
    axios({
      method: 'get', //  you can set what request you want to be
      url: `https://cdn.umbraco.io/content/search?term=${term}&page=1&pageSize=1000`,
      headers: {
        'umb-project-alias': process.env.GATSBY_UMBRACO_ENVIRONMENT,
        'Content-Type': 'application/json',
        'Accept-Language': dir === 'rtl' ? 'ar' : 'en-US',
      },
    })
      .then((res) => {
        const allowedResults =
          res.data._embedded && res.data._embedded.content
            ? res.data._embedded.content.filter((r) => allowedTypes.includes(r.contentTypeAlias))
            : [];
        setResults([...allowedResults]);
        setCurrentItems([...allowedResults].slice(0, itemsPerPage));
        setPageCount(Math.ceil(allowedResults.length / itemsPerPage));
        setLoading(false);
        setError('');
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  };

  const handlePageClick = ({ selected: selectedPage }) => {
    setCurrentPage(selectedPage);
  };

  useEffect(() => {
    doSearch();
  }, []);

  useEffect(() => {
    const offset = currentPage * itemsPerPage;
    setCurrentItems([...results].slice(offset, offset + itemsPerPage));
  }, [currentPage]);

  const updateTerm = (e) => {
    e.preventDefault();
    setTerm(e.target.value);
    e.target.focus();
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      doSearch();
    }
  };
  return (
    <SearchResultsContainer id={id}>
      <Container>
        <Row className="searchInput">
          <Column>
            <StyledInput type="text" value={term} onChange={updateTerm} onKeyDown={handleKeyDown} />
          </Column>
        </Row>
        <Row>
          <Column>
            {error && <div>${error}</div>}
            {currentItems && currentItems.length > 0 && (
              <div>
                <div>
                  {currentItems.map((r, index) => (
                    <div key={`search-${index}`} className="searchResultItem">
                      <h3>
                        <Link to={r._url}>{r.title}</Link>
                      </h3>
                      <p>{r.description}</p>
                    </div>
                  ))}
                </div>
                <ReactPaginate
                  className="pagination"
                  breakLabel="..."
                  nextLabel=">"
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={5}
                  pageCount={pageCount}
                  previousLabel="<"
                  renderOnZeroPageCount={null}
                  forcePage={currentPage}
                />
              </div>
            )}
            {!loading && currentItems.length === 0 && <div>No results found</div>}
          </Column>
        </Row>
      </Container>
    </SearchResultsContainer>
  );
}

export default SearchResults;
